import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { INDUSTRY_TYPE } from '../../../common/constant'
import { Input } from '../../../common/input'
import {
  changeIndustryTab,
  selectCurrentIndustryTab,
} from './../../store/slice'
import { ICB } from './ICB'
import classes from './index.module.scss'
import { VSIC } from './VSIC'

export const Industry = () => {
  const dispatch = useDispatch()

  const currentTab = useSelector(selectCurrentIndustryTab)

  const [keyword, setKeyword] = useState('')

  const changeTab = (key) => {
    dispatch(changeIndustryTab(key))
  }

  const renderIndustryType = () => {
    switch (currentTab) {
      case INDUSTRY_TYPE.VSIC:
        return <VSIC keyword={keyword} />
      case INDUSTRY_TYPE.ICB:
        return <ICB keyword={keyword} />
      default:
        return <></>
    }
  }

  return (
    <Element className={classes.industry}>
      <Element className={classes.industryType}>
        {Object.keys(INDUSTRY_TYPE).map((key) => (
          <Element
            key={key}
            style={{
              color: key === currentTab ? '#FFFFFF' : '',
              backgroundColor: key === currentTab ? '#2C73E8' : '#FFFFFF',
            }}
            onClick={() => changeTab(key)}
          >
            {key}
          </Element>
        ))}
      </Element>

      <Input
        noControl
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        placeholder={UseI18n('screening.SEARCH_INDUSTRY')}
        inputStyle={{ fontSize: 14 }}
        wrapperStyle={{ backgroundColor: '#FFFFFF', padding: '5px 12px' }}
        wrapperClassname={classes.industrySearch}
        prefix={
          <Icon className="icon-search pr1" style={{ color: '#9C9C9C' }} />
        }
      />

      <Element className={classes.industryTree}>
        <ScrollComponent>
          <Element className={classes.px20}>{renderIndustryType()}</Element>
        </ScrollComponent>
      </Element>
    </Element>
  )
}
